import { render, staticRenderFns } from "./newMakeUpAGroup.vue?vue&type=template&id=453d59ce&scoped=true&"
import script from "./newMakeUpAGroup.vue?vue&type=script&lang=js&"
export * from "./newMakeUpAGroup.vue?vue&type=script&lang=js&"
import style0 from "./newMakeUpAGroup.vue?vue&type=style&index=0&id=453d59ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d59ce",
  null
  
)

export default component.exports